<template>
  <responsive-modal v-model="visible" size="lg">
    <div class="modal-invoice-details p-5" v-if="invoice">
      <div class="d-flex justify-content-between align-items-center">
        <h5>
          Detalhes da nota fiscal
        </h5>
        <button class="btn btn-sm text-secondary" @click="visible = false">
          <i class="icon-x fs-20" />
        </button>
      </div>

      <button
        class="btn btn-primary btn-sm btn-40 export-button"
        @click="exportData"
      >
        <loading :show="exportLoading">
          <i class="fa fa-download mx-2" />
          <span class="px-5">Exportar</span>
        </loading>
      </button>

      <b-tabs class="mt-5">
        <b-tab title="Dados do cliente" active class="pt-6">
          <small>Nome do cliente</small>
          <div class="form-control d-flex align-items-center mb-5">
            {{ invoice.shopper_name }}
          </div>
          <small>Documento de identificação</small>
          <div class="form-control d-flex align-items-center mb-5">
            {{ invoice.shopper_document }}
          </div>
          <small>E-mail do cliente</small>
          <div class="form-control d-flex align-items-center mb-5">
            {{ invoice.shopper_email }}
          </div>
        </b-tab>

        <b-tab title="Informações da compra" class="pt-6">
          <small>Nome do produto</small>
          <div class="form-control d-flex align-items-center mb-5">
            {{ invoice.product_name }}
          </div>
          <div class="row">
            <div class="col-lg-6">
              <small>Valor (R$)</small>
              <div class="form-control d-flex align-items-center mb-5">
                {{ formatMoney(invoice.amount) }}
              </div>
            </div>
            <div class="col-lg-6">
              <small>Método de pagamento</small>
              <div class="form-control d-flex align-items-center mb-5">
                {{ invoice.payment_method }}
              </div>
            </div>
            <div class="col-lg-6">
              <small>Data de emissão</small>
              <div class="form-control d-flex align-items-center mb-5">
                {{ invoice.send_at | formatDate }}
              </div>
            </div>
            <div class="col-lg-6">
              <small>Hora de emissão</small>
              <div class="form-control d-flex align-items-center mb-5">
                {{ invoice.send_at | formatTime }}
              </div>
            </div>
            <div class="col-lg-6">
              <small>Data de competência</small>
              <div class="form-control d-flex align-items-center">
                {{ invoice.paid_at | formatDate }}
              </div>
            </div>
            <div class="col-lg-6 mt-5 mt-lg-0">
              <small>Número / Série</small>
              <form-group
                v-model="form.invoice_number"
                id="invoice-number"
                class="py-0"
              />
            </div>
            <div class="col-lg-6">
              <form-group
                label="Envio"
                id="type-select"
                select
                v-model="form.send_type"
                :options="sendTypes"
              />
            </div>
            <div class="col-lg-6">
              <form-group
                label="Status"
                select
                :disabled="form.send_type == 'automatic'"
                v-model="form.status"
                id="status-select"
                :options="statusOptions"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </responsive-modal>
</template>
<script>
import { formatMoney, formFields } from "@/functions/helpers";
import SaleMixin from "@/mixins/sale";
import moment from "moment";

export default {
  mixins: [SaleMixin],
  filters: {
    formatTime(val) {
      return val ? moment(val).format("hh:mm:ss") : "-";
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    invoice: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      exportLoading: false,
      visible: false,
      ...formFields(["send_type", "status"])
    };
  },
  computed: {
    canExport() {
      return false;
    },
    statusOptions() {
      return [
        { id: "sent", name: "Enviado" },
        { id: "pending", name: "Pendente" },
        { id: "failed", name: "Falha" },
        { id: "canceled", name: "Cancelado" }
      ];
    },
    sendTypes() {
      return [
        { id: "manual", name: "Manual" },
        { id: "automatic", name: "Automático" }
      ];
    }
  },
  watch: {
    value(v) {
      this.visible = v;
      if (!v) {
        let params = {
          ...this.form
        };
        if (params.status === this.invoice.status) delete params.status;
        this.$store
          .dispatch("invoiceNfe/putInvoices", params)
          .then(() => this.$emit("refresh"));
      }
    },
    visible(v) {
      this.$emit("input", v);
    },
    invoice(v) {
      if (v)
        this.form = {
          id: v.id,
          send_type: v.send_type,
          status: v.status,
          invoice_number: v.invoice_number
        };
    }
  },
  methods: {
    async exportData() {
      try {
        this.exportLoading = true;
        let params = {
          id: this.invoice.id,
          export: true
        };

        const CSVContent = await this.$store
          .dispatch("invoiceNfe/getDetailsCSV", params)
          .then();
        var a = document.createElement("a");

        a.href = `data:text/csv;charset=utf-8,${CSVContent.replaceAll(
          "#",
          "%23"
        )}`;
        a.setAttribute("download", `invoice_${this.invoice.id}.csv`);
        a.click();
      } catch (e) {
      } finally {
        this.exportLoading = false;
      }
    },
    formatMoney(val) {
      return formatMoney(val);
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-invoice-details {
  h5 {
    font-size: 18px;
    font-weight: normal;
    color: rgba(87, 88, 107, 0.88);
    margin-bottom: unset !important;
  }
  ::v-deep .form-group {
    .form-control {
      border-color: #e1e1e1;
    }
  }
  .export-button {
    position: absolute;
    right: 32px;
    top: 81px;
    padding: 8px;
    @media screen and (max-width: 991px) {
      position: inherit;
      width: 100%;
      margin: 16px 0 0;
    }
  }
  ::v-deep .nav-tabs {
    border-bottom: none;
    .nav-link {
      padding: 12px;
      &.active,
      .nav-item.show {
        font-size: 14px;
      }
      &:hover,
      &:focus {
        font-size: 14px;
      }
    }
  }
}
</style>
